export default {"src":"/_next/static/media/Ton.09dc4ed9.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};